module.exports = __webpack_public_path__ + "img/source_book-item13.7e059088.png";